// extracted by mini-css-extract-plugin
export default {"list":"crowd-comfort_list__vZbnB"};